import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import paymentsReducer from '../resui/payments/sagas/residentpaymentsSlice';
import pmReducer from '../pmui/transactions/sagas/pmTransactionsSlice';
import authReducer, { clearCredentials } from '../shared/sagas/auth/authSlice';
import createSagaMiddleware from 'redux-saga';
import pmOnboardingSaga from '../pmui/onboarding/sagas/pmonboardingSaga';
import pmOnboardingReducer from '../pmui/onboarding/sagas/pmonboardingSlice';
import { residentPaymentsSaga } from '../resui/payments/sagas/residentpaymentsSaga';
import { pmPaymentsSaga } from '../pmui/transactions/sagas/pmTransactionsSaga';
import authSaga from '../shared/sagas/auth/authSaga';
import pmDepositsReducer from '../pmui/deposits/sagas/pmDepositsSlice';
import { pmDepositsSaga } from '../pmui/deposits/sagas/pmDepositsSaga';
import associatedPMsReducer from '../pmui/accountManagement/sagas/accountManagementSlice';
import { pmAccountManagementSaga } from '../pmui/accountManagement/sagas/accountManagementSaga';
import pmPropertiesReducer from '../pmui/properties/sagas/pmPropertiesSlice';
import { pmPropertiesSaga } from '../pmui/properties/sagas/pmPropertiesSaga';
import { pmIntegrationSaga } from '../pmui/integrations/sagas/pmIntegrationSaga';
import pmIntegrationReducer from '../pmui/integrations/sagas/pmIntegrationSlice';
import pmConfigSettingsReducer from '../pmui/configSettings/sagas/pmConfigSettingsSlice';
import { pmConfigSettingsSaga } from '../pmui/configSettings/sagas/pmConfigSettingsSaga';
import pmResidentsReducer from '../pmui/residents/saga/pmResidentsSlice';
import { pmResidentsSaga } from '../pmui/residents/saga/pmResidentsSaga';
import invitationReducer from '../shared/signup/sagas/invitations/invitationSlice';
import { rsInvitationSaga } from '../shared/signup/sagas/invitations/invitationSaga';
import pmDashboardReducer from '../pmui/dashboard/sagas/pmDashboardSlice';
import { pmDashboardDataSaga } from '../pmui/dashboard/sagas/pmDashboardSaga';
import { paymentRequestsSaga } from '../pmui/paymentrequests/sagas/paymentrequestsaga';
import paymentRequestsReducer from '../pmui/paymentrequests/sagas/paymentrequestslice';
import notificationSettingsReducer from "../shared/notificationSettings/sagas/notificationSettingSlice";
import notificationSettingsSaga from "../shared/notificationSettings/sagas/notificationSettingSaga";
import adminReducer from '../adminPortal/sagas/adminPortal.slice';
import billingReducer from '../pmui/billingConfiguration/sagas/billingSlice';
import { portalSaga } from '../adminPortal/sagas/adminPortal.saga';
import billingSaga from '../pmui/billingConfiguration/sagas/billingSaga';
import documentReducer from '../shared/sagas/document/documentSlice';
import maintenanceReducer from '../resui/maintenance/sagas/MaintenanceSlice';
import { maintenanceSaga } from '../resui/maintenance/sagas/MaintenanceSaga';
import { documentSaga } from '../shared/sagas/document/documentSaga';
import bankAccountsReducer from '../shared/sagas/bankAccounts/bankAccountsSlice';
import { bankAccountsSaga } from '../shared/sagas/bankAccounts/bankAccountsSaga';
import ownersReducer from '../pmui/owners/sagas/ownersSlice';
import { ownersSaga } from '../pmui/owners/sagas/ownersSaga';
import pmDisbursementsReducer from '../pmui/ownerDistributions/sagas/pmDisbursementsSlice';
import { pmDisbursementsSaga } from '../pmui/ownerDistributions/sagas/pmDisbursemebtsSaga';
import applicationsReducer from '../resui/applications/sagas/pm/applicationsSlice';
import { applicationsSaga } from '../resui/applications/sagas/pm/applicationsSaga';
import applicantsReducer from '../resui/applications/sagas/applicants/applicantsSlice';
import applicantsSaga from '../resui/applications/sagas/applicants/applicantsSaga';
import workOrderReducer from '../pmui/workorders/sagas/workorderSlice';
import { workOrderSaga } from '../pmui/workorders/sagas/workorderSaga';
import quickPaymentsReducer from '../resui/quickpayments/sagas/quickpaymentsSlice';
import { quickPaymentsSaga } from '../resui/quickpayments/sagas/quickpaymentsSaga';
import acknowledgementsReducer from '../pmui/acknowledgements/sagas/acknowledgementsSlice';
import { acknowledgementsSaga } from '../pmui/acknowledgements/sagas/acknowledgementsSaga';
import vendorsReducer from '../pmui/vendors/sagas/vendorsSlice';
import { vendorsSaga } from '../pmui/vendors/sagas/vendorsSaga';
import propertyGroupsReducer from '../shared/sagas/propertyGroups/propertyGroupsSlice';
import { propertyGroupsSaga } from '../shared/sagas/propertyGroups/propertyGroupsSaga';
import ownerDocumentsReducer from '../ownerui/documents/sagas/documentsSlice';
import { ownerDocumentsSaga } from '../ownerui/documents/sagas/documentsSaga';
import ownerLedgerReducer from "../ownerui/ledger/sagas/OwnerLedgerSlice";
import { ownerLedgerSaga } from "../ownerui/ledger/sagas/OwnerLedgerSaga";
import announcementReducer from '../pmui/announcements/sagas/announcementSlice'
import { announcementSaga } from '../pmui/announcements/sagas/announcementSaga';
const sagaMiddleware = createSagaMiddleware({ context: { life: `bowl of cherries` } });

const combinedReducer = combineReducers({
  pmtsModuleState: paymentsReducer,
  auth: authReducer,
  pmModuleState: pmReducer,
  pmOnboarding: pmOnboardingReducer,
  pmDpModuleState: pmDepositsReducer,
  pmAMModuleState: associatedPMsReducer,
  pmPropertyModuleState: pmPropertiesReducer,
  pmIntegrationState: pmIntegrationReducer,
  pmResidentsModuleState: pmResidentsReducer,
  invitation: invitationReducer,
  pmDashboardState: pmDashboardReducer,
  pmConfigSettingsState: pmConfigSettingsReducer,
  paymentRequestsState: paymentRequestsReducer,
  notificationSettingsState: notificationSettingsReducer,
  adminState: adminReducer,
  billingState: billingReducer,
  documentState: documentReducer,
  maintenanceState: maintenanceReducer,
  bankAccountModuleState: bankAccountsReducer,
  ownerModuleState: ownersReducer,
  pmDisbursementsState: pmDisbursementsReducer,
  applicationsState: applicationsReducer,
  applicantsState: applicantsReducer,
  workOrderState: workOrderReducer,
  quickPaymentState: quickPaymentsReducer,
  acknowledgementsState: acknowledgementsReducer,
  vendorsState: vendorsReducer,
  propertyGroupsState: propertyGroupsReducer,
  ownerDocumentModuleState: ownerDocumentsReducer,
  ownerLedgerState: ownerLedgerReducer,
  announcementState: announcementReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === clearCredentials.type) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.documents', 'payload.BankAccount.BankFiles', 'payload.data.BankAccount.BankFiles'],
        ignoredPaths: ['pmOnboarding.onboarding.BankAccount.BankFiles'],
      },
    }).concat(sagaMiddleware),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

sagaMiddleware.run(pmPaymentsSaga);
sagaMiddleware.run(residentPaymentsSaga);
sagaMiddleware.run(authSaga);
sagaMiddleware.run(pmDepositsSaga);
sagaMiddleware.run(pmAccountManagementSaga);
sagaMiddleware.run(pmOnboardingSaga);
sagaMiddleware.run(pmPropertiesSaga);
sagaMiddleware.run(pmResidentsSaga);
sagaMiddleware.run(pmIntegrationSaga);
sagaMiddleware.run(rsInvitationSaga);
sagaMiddleware.run(pmDashboardDataSaga);
sagaMiddleware.run(pmConfigSettingsSaga);
sagaMiddleware.run(paymentRequestsSaga);
sagaMiddleware.run(notificationSettingsSaga);
sagaMiddleware.run(portalSaga);
sagaMiddleware.run(billingSaga);
sagaMiddleware.run(documentSaga);
sagaMiddleware.run(bankAccountsSaga);
sagaMiddleware.run(ownersSaga);
sagaMiddleware.run(pmDisbursementsSaga);
sagaMiddleware.run(maintenanceSaga);
sagaMiddleware.run(applicationsSaga);
sagaMiddleware.run(applicantsSaga);
sagaMiddleware.run(workOrderSaga);
sagaMiddleware.run(quickPaymentsSaga);
sagaMiddleware.run(acknowledgementsSaga);
sagaMiddleware.run(vendorsSaga);
sagaMiddleware.run(propertyGroupsSaga);
sagaMiddleware.run(ownerDocumentsSaga);
sagaMiddleware.run(ownerLedgerSaga);
sagaMiddleware.run(announcementSaga)

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export interface ErrorType{
  message: string
  statusCode: number
}